// Load game
!(function () {
    'use strict';
    !(function () {
        let el = document.getElementById('js_game');
        if (el) {
            const demo_url = el.getAttribute('data-game');
            let demo_btn = document.getElementById('demo_btn');
            let play_btn = document.getElementById('play_btn'); // The casino button

            function openFullscreen(elem) {
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    /* Firefox */
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) {
                    /* Chrome, Safari & Opera */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) {
                    /* IE/Edge */
                    elem.msRequestFullscreen();
                }
            }

            function closeFullscreen() {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    /* Firefox */
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    /* Chrome, Safari and Opera */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    /* IE/Edge */
                    document.msExitFullscreen();
                }
            }

            function isMobileDevice() {
                return window.matchMedia('only screen and (max-width: 760px)').matches;
            }

            if (el && demo_url && demo_btn) {
                demo_btn.addEventListener('click', function () {
                    let iframe = document.createElement('iframe');
                    iframe.setAttribute('src', demo_url);
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    el.innerHTML = '';
                    el.appendChild(iframe);

                    if (isMobileDevice()) {
                        let clonedPlayBtn = play_btn.cloneNode(true);
                        clonedPlayBtn.style.display = 'block'; // Ensure the button is visible
                        el.appendChild(clonedPlayBtn); // Append the cloned button to el

                        let closeButton = document.createElement('button');
                        closeButton.innerHTML = '&#10006;'; // Unicode for a simple 'X' character
                        closeButton.id = 'close_btn';
                        closeButton.onclick = closeFullscreen;
                        el.appendChild(closeButton);

                        // Event listener for fullscreen change
                        document.addEventListener('fullscreenchange', function () {
                            if (!document.fullscreenElement) {
                                // Remove the close button when exiting fullscreen
                                let closeButton = document.getElementById('close_btn');
                                if (closeButton) {
                                    closeButton.parentNode.removeChild(closeButton);
                                }
                            }
                        });

                        openFullscreen(el); // Open the container in fullscreen
                    }

                    demo_btn.style.display = 'none';
                });
            }
        }
    })();
})();
